import { useSelector } from "react-redux";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { RootState } from "../../../redux/store";
import { getClaimServiceIndicatorBarChartData } from "../api/ClaimAPI";
import { useQuery } from "@tanstack/react-query";
import i18n from "../../../i18n";
import { PaginationFilterDto } from "../../../types/Pagination";

type QueryFnTypeClaimServiceIndicatorBarChartData = typeof getClaimServiceIndicatorBarChartData;

export const useClaimServiceIndicatorBarChartData = (config?: QueryConfig<QueryFnTypeClaimServiceIndicatorBarChartData>) => {
    const filters = useSelector((state: RootState) => state.filters.claims.selectedFilters);
    const filterByUser = useSelector((state: RootState) => state.filters.claims.filterByCurrentUser ?? false);
    const currentUser = useSelector((state: RootState) => state.currentUserInfo.data);

    const paginationFilters: PaginationFilterDto = {
        filters,
        selectedOrganizationalStructureIds: currentUser.selectedOrganizationalStructureIds,
        filterByCurrentUser: filterByUser,
        pageNumber: 1,
        pageSize: 1
    };

    return useQuery<ExtractFnReturnType<QueryFnTypeClaimServiceIndicatorBarChartData>>({
        ...config,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ["ClaimServiceIndicatorBarChartData", filterByUser, filters, i18n.language, currentUser],
        queryFn: () => getClaimServiceIndicatorBarChartData(paginationFilters),
    });
}
